import { Component, computed, input } from '@angular/core';

import {
	ASYMMETRIC_SLIDER_CONFIG,
	AsymmetricImageSlideComponent,
} from '@valk-nx/components/ui-slider/src/lib/asymmetric-image-slide/asymmetric-image-slide';
import { SliderNavButtonComponent } from '@valk-nx/components/ui-slider/src/lib/nav-button/nav-button';
import { SliderComponent } from '@valk-nx/components/ui-slider/src/lib/slider';
import type { PhotoInterface } from '@valk-nx/core/lib/interfaces/image.interface';
import { AnchorComponent } from '@valk-nx/storyblok/components/anchor/src/lib/anchor';
import { HeadingGroupSectionComponent } from '@valk-nx/storyblok/components/heading-group-section/src/lib/heading-group-section';
import { MarkdownComponent } from '@valk-nx/storyblok/components/markdown/src/lib/markdown';
import { renderStoryblokRichTextAsText } from '@valk-nx/storyblok/components/richtext/src/lib/render';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import { StoryblokHelper } from '@valk-nx/storyblok-helpers/src/lib/general/storyblok.helper';
import type {
	Button,
	HeadingGroupSection,
	StoryblokImage,
} from '@valk-nx/storyblok-types/src/lib/types/storyblok.interface';

@Component({
	selector: 'sb-image-slider-section',
	templateUrl: './image-slider-section.html',
	imports: [
		AnchorComponent,
		AsymmetricImageSlideComponent,
		HeadingGroupSectionComponent,
		MarkdownComponent,
		SliderComponent,
		SliderNavButtonComponent,
		StoryblokDirective,
	],
})
export class StoryblokImageSliderComponent extends StoryblokRootDirective {
	title = input.required<HeadingGroupSection[]>();
	images = input<StoryblokImage[]>([]);
	button = input<Button[]>();

	protected readonly sliderConfig = ASYMMETRIC_SLIDER_CONFIG;

	heading = computed<HeadingGroupSection | undefined>(() => this.title()[0]);

	content = computed<string>(() => this.heading()?.content ?? '');

	sliderLabel = computed<string>(() =>
		renderStoryblokRichTextAsText(this.heading()?.title),
	);

	/** An item without a Bynder asset has nothing to show, so it is left out. */
	slides = computed<PhotoInterface[]>(() =>
		this.images()
			.filter((item) => item.bynder?.[0]?.files?.transformBaseUrl?.url)
			.map((item) =>
				StoryblokHelper.mapBynderToPhotoInterface(
					item.bynder[0],
					item.imageAlt,
				),
			),
	);

	trackBySrc = (slide: PhotoInterface) => slide.src;
}
